import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { ITicketRangeControl } from '../interface/LawFirm/ITicketRangeControl';
import { ITicketRangeControlRequest } from '../interface/LawFirm/ITicketRangeControlRequest';
import { ILawFirmScore } from '../interface/LawFirm/ILawFirmScore';

enum TicketControlServiceEnum {
  base = "",
  getByUser = "get-by-user/",
  getAll = "",
  getAllLawFirmScores = "get-all-law-firm-scores/",
  UpdateLawFirmScores = "update-law-firm-scores"

}

export default class TicketControlService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/ticket/control/");
  }

  public saveConfigs = async (data: ITicketRangeControlRequest): Promise<void> => await this.POST(TicketControlServiceEnum.base, data, "text");
  public deleteConfig = async (ticketConfigId: number) => await this.DELETE(TicketControlServiceEnum.base + ticketConfigId, "text");
  public getTicketControls = async (idUser: number): Promise<ITicketRangeControl[]> => await this.GET(TicketControlServiceEnum.getByUser + idUser);
  public getAllTickets = async (): Promise<ITicketRangeControl[]> => await this.GET(TicketControlServiceEnum.getAll);
  public getAllLawFirmScores = async (): Promise<ILawFirmScore[]> => await this.GET(TicketControlServiceEnum.getAllLawFirmScores);
  public updateLawFirmScores = async (data: ILawFirmScore[]): Promise<void> => await this.POST(TicketControlServiceEnum.UpdateLawFirmScores, data, "json");
}